module.exports = __webpack_public_path__ + "media/images/costumes/top/logo/logo-6-42356a4dc5772bb01c5d60d66583c827.png";